module.exports = __webpack_public_path__ + "static/better-employee-elizabeth-700w-897bbb49b6763f0b0f62ca6e6a6fecd8.jpg";